import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from './environment.model';

const parseCSV = (value?: string): string[] =>
  value
    ? value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    : [];

const parseBoolean = (value?: string): boolean => value === 'true';

export const parseLayerEnvironment = (config: Record<string, string>): Environment => {
  const baseEnvironment = parseAgrEnvironment(config);

  return {
    ...baseEnvironment,
    MY_OFFICE_URL: config.MY_OFFICE_URL,
    INSTANT_ORDER: parseBoolean(config.INSTANT_ORDER),
    IDENTIFICATION_TYPES_NL: parseCSV(config.IDENTIFICATION_TYPES_NL),
    IDENTIFICATION_WARNING_PERIOD: config.IDENTIFICATION_WARNING_PERIOD,
    DELIVERY_TIME_WINDOW_DISABLED: parseBoolean(config.DELIVERY_TIME_WINDOW_DISABLED),
    SHOW_DISABLED_LOCATION_BADGE: parseBoolean(config.SHOW_DISABLED_LOCATION_BADGE),
    USE_POULTRY_SERVICE: parseBoolean(config.USE_POULTRY_SERVICE),
    BREEDERS_ENABLED: parseBoolean(config.BREEDERS_ENABLED),
  } as Environment;
};
